import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  FormsModule,
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { TableModule } from 'primeng/table';
import { TooltipModule } from 'primeng/tooltip';
import { InstituteCommonDetailsResponse } from '../../../models/institute/instituteCommonDetailsResponse';
import { InstituteService } from '../../../services/institute/institute.service';
import {
  InstituteAgentResponse,
  InstituteAgentRequest,
} from '../../../models/institute/instituteAgentResponse';
import { MessageService } from 'primeng/api';
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-manage-agents',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    InputSwitchModule,
    InputTextModule,
    InputNumberModule,
    TableModule,
    TooltipModule,
    CheckboxModule 
  ],
  templateUrl: './manage-agents.component.html',
  styleUrls: ['./manage-agents.component.scss'],
})
export class ManageAgentsComponent implements OnInit {
  @Input() institute: InstituteCommonDetailsResponse | null | undefined;
  @Input() visible: boolean = false;
  @Output() closeDialog = new EventEmitter<void>();

  agentForm: FormGroup;
  agent: InstituteAgentResponse | null = null;
  isLoading: boolean = false;
  isSaving: boolean = false;
  editingAgentId: number | null = null;

  agentOptions = [
    { label: 'KC', value: 1 },
    { label: 'CM', value: 2 },
    { label: 'CAE', value: 3 },
    { label: 'Direct', value: 4 },
    { label: 'SIUK', value: 5 },
  ];

  currency = [
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
    { label: 'GBP', value: 'GBP' },
    { label: 'INR', value: 'INR' },
  ];

  months = [
    { label: 'Fall', value: 'Fall' },
    { label: 'Spring', value: 'Spring' },
    // { label: 'January', value: 'January' },
    // { label: 'February', value: 'February' },
    // { label: 'March', value: 'March' },
    // { label: 'April', value: 'April' },
    // { label: 'May', value: 'May' },
    // { label: 'June', value: 'June' },
    // { label: 'July', value: 'July' },
    // { label: 'August', value: 'August' },
    // { label: 'September', value: 'September' },
    // { label: 'October', value: 'October' },
    // { label: 'November', value: 'November' },
    // { label: 'December', value: 'December' }
  ];

  years: { label: string; value: string }[] = [];

  constructor(
    private fb: FormBuilder,
    private instituteService: InstituteService,
    private messageService: MessageService,
  ) {
    this.agentForm = this.fb.group({
      isCommissionable: [false],
      // isCommissionable: [false, [Validators.requiredTrue]],
      agent: [{ value: null, disabled: true }],
      sopLink: [''],
      currency: [null],
      applicationFees: [null],
      intakeMonth: [null],
      intakeYear: [null],
      feeWaiver: [false],
    });

    // this.agentForm.get('isCommissionable')?.valueChanges.subscribe(isComm => {
    //     if (isComm) {
    //         this.agentForm.get('agent')?.enable();
    //     } else {
    //         this.agentForm.get('agent')?.disable();
    //         this.agentForm.get('agent')?.setValue(null);
    //     }
    // });
    // Partner toggle: agent required only when Partner is ON
    // this.agentForm.get('isCommissionable')?.valueChanges.subscribe((isComm) => {
    //   const agentCtrl = this.agentForm.get('agent');
    //   if (isComm) {
    //     agentCtrl?.enable();
    //     agentCtrl?.setValidators([Validators.required]);
    //   } else {
    //     agentCtrl?.clearValidators();
    //     // agentCtrl?.setValue(null);
    //     agentCtrl?.disable();
    //   }
    //   agentCtrl?.updateValueAndValidity();
    // });

    // // Fee waiver: lock the fee field when checked
    // this.agentForm.get('feeWaiver')?.valueChanges.subscribe((waived) => {
    //   const feesCtrl = this.agentForm.get('applicationFees');
    //   if (waived) {
    //     feesCtrl?.setValue(null);
    //     feesCtrl?.disable();
    //   } else {
    //     feesCtrl?.enable();
    //   }
    // });
    // Partner toggle: Non-Partner disables everything, values are kept
this.agentForm.get('isCommissionable')?.valueChanges.subscribe((isComm) => {
  this.applyPartnerState(!!isComm);
});

// Fee waiver: lock the fee field when checked (only while Partner)
this.agentForm.get('feeWaiver')?.valueChanges.subscribe((waived) => {
  if (!this.agentForm.get('isCommissionable')?.value) return;
  const feesCtrl = this.agentForm.get('applicationFees');
  if (waived) {
    feesCtrl?.setValue(null);
    feesCtrl?.disable({ emitEvent: false });
  } else {
    feesCtrl?.enable({ emitEvent: false });
  }
});
    const currentYear = new Date().getFullYear();
    for (let i = 0; i < 6; i++) {
      const y = currentYear + i;
      this.years.push({ label: y.toString(), value: y.toString() });
    }
  }

  ngOnInit(): void {
    if (this.institute?.id) {
      this.loadAgents();
    }
  }
private applyPartnerState(isPartner: boolean): void {
  const agentCtrl = this.agentForm.get('agent');
  const feesCtrl = this.agentForm.get('applicationFees');
  const otherFields = ['sopLink', 'currency', 'intakeMonth', 'intakeYear', 'feeWaiver'];

  if (isPartner) {
    agentCtrl?.enable({ emitEvent: false });
    agentCtrl?.setValidators([Validators.required]);
    otherFields.forEach((f) => this.agentForm.get(f)?.enable({ emitEvent: false }));

    // fee field stays locked if Fee Waiver is checked
    if (this.agentForm.get('feeWaiver')?.value) {
      feesCtrl?.disable({ emitEvent: false });
    } else {
      feesCtrl?.enable({ emitEvent: false });
    }
  } else {
    agentCtrl?.clearValidators();
    agentCtrl?.disable({ emitEvent: false });
    otherFields.forEach((f) => this.agentForm.get(f)?.disable({ emitEvent: false }));
    feesCtrl?.disable({ emitEvent: false });
  }

  agentCtrl?.updateValueAndValidity({ emitEvent: false });
}
  loadAgents(): void {
    if (!this.institute?.id) return;
    this.isLoading = true;

    this.instituteService.getAgents(this.institute.id).subscribe({
      next: (response: InstituteAgentResponse) => {
        this.isLoading = false;

        if (response && response.id > 0) {
          this.agent = response;
          this.editAgent(response);
        } else {
          this.agent = null;
          this.showAddForm();
        }
      },
      error: (err) => {
        console.error('Error loading agents:', err);
        this.isLoading = false;
        this.showAddForm();
      },
    });
  }
showAddForm(): void {
  this.editingAgentId = null;
  this.agentForm.reset({
    agent: null,
    sopLink: '',
    isCommissionable: false,
    currency: null,
    applicationFees: null,
    intakeMonth: null,
    intakeYear: null,
    feeWaiver: false,
  });
  this.applyPartnerState(false);
}
  // showAddForm(): void {
  //   this.editingAgentId = null;
  //   this.agentForm.reset({
  //     agent: null,
  //     sopLink: '',
  //     isCommissionable: false,
  //     currency: null,
  //     applicationFees: null,
  //     intakeMonth: null,
  //     intakeYear: null,
  //   });
  //   this.agentForm.get('agent')?.clearValidators();
  //   this.agentForm.get('agent')?.disable();
  //   this.agentForm.get('applicationFees')?.enable();
  // }

  editAgent(agent: InstituteAgentResponse): void {
    this.editingAgentId = agent.id > 0 ? agent.id : null;

     const feeStr = agent.applicationFees;
    const feeNum = feeStr !== null && feeStr !== undefined && feeStr !== '' ? parseFloat(feeStr) : null;
    const isWaived = feeNum === 0;

    this.agentForm.patchValue({
      agent: agent.agent,
      isCommissionable: agent.isCommissionable ?? false,
      sopLink: agent.applicationProcessingSop || '',
      currency:
        agent.currency === 0
          ? 'USD'
          : agent.currency === 1
            ? 'INR'
            : agent.currency === 2
              ? 'EUR'
              : agent.currency === 3
                ? 'GBP'
                : 'USD',
    //   applicationFees:
    //     agent.applicationFees && parseFloat(agent.applicationFees) > 0
    //       ? parseFloat(agent.applicationFees)
    //       : null,
     applicationFees: feeNum !== null && feeNum > 0 ? feeNum : null,
        feeWaiver: isWaived,
      intakeMonth: agent.intakeMonth || null,
      intakeYear: agent.intakeYear || null,
    });
 this.applyPartnerState(!!agent.isCommissionable);
    // if (agent.isCommissionable) {
    //   this.agentForm.get('agent')?.enable();
    // } else {
    //   this.agentForm.get('agent')?.disable();
    // }
  }

  onSubmit(): void {
    this.agentForm.markAllAsTouched();
    if (this.agentForm.invalid || !this.institute?.id) return;

    this.isSaving = true;
     const formValue = this.agentForm.getRawValue(); 
    // const formValue = this.agentForm.value;
    let applicationFees = '';
    if (formValue.feeWaiver) {
      applicationFees = '0';
    } else if (
      formValue.applicationFees !== null &&
      formValue.applicationFees !== undefined &&
      formValue.applicationFees !== ''
    ) {
      applicationFees = formValue.applicationFees.toString();
    }
    const agentData: InstituteAgentRequest = {
      id: 0,
      instituteId: this.institute.id,
      agent: formValue.agent || '',
      isCommissionable: formValue.isCommissionable,
      applicationProcessingSop: formValue.sopLink,
      applicationFees: applicationFees,
      // applicationFees: formValue.applicationFees?.toString() || '0',
      intakeMonth: formValue.intakeMonth || '',
      intakeYear: formValue.intakeYear || '',
      currency:
        formValue.currency === 'USD'
          ? 0
          : formValue.currency === 'INR'
            ? 1
            : formValue.currency === 'EUR'
              ? 2
              : formValue.currency === 'GBP'
                ? 3
                : 0,
    };

    if (this.editingAgentId) {
      agentData.id = this.editingAgentId;

      this.instituteService.updateAgent(agentData).subscribe({
        next: (response: InstituteAgentResponse) => {
          this.isSaving = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Agent settings updated successfully',
          });
          this.onClose();
        },
        error: (err) => {
          this.isSaving = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to update agent settings.',
          });
        },
      });
    } else {
      this.instituteService.saveAgent(agentData).subscribe({
        next: (response: InstituteAgentResponse) => {
          this.isSaving = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Agent settings saved successfully',
          });
          this.onClose();
        },
        error: (err) => {
          this.isSaving = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Failed to save agent settings.',
          });
        },
      });
    }
  }

  onClose(): void {
    this.closeDialog.emit();
  }
}
